module.exports = __webpack_public_path__ + "static/img/icon-overview-phone.611b92c1.png";